import styled from 'styled-components'

import { Accordion as LMFAccordion, TypeStyle } from '@syconium/little-miss-figgy'

export const Accordion = styled(LMFAccordion)``
export const Section = styled(LMFAccordion.Section)``
export const Header = styled(LMFAccordion.Header)`
  ${TypeStyle.css.headlineMicro}
  text-transform: uppercase;
  justify-content: space-between;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  line-height: 18px;
  padding: ${props => props.theme.spacing(6)} 0 ${props => props.theme.spacing(2)} 0;

  div {
    flex-basis: initial;
  }
`

export const Body = styled(LMFAccordion.Body)`
  width: 100%;
  height: 100%;
  padding-left: 0px;
  padding-right: 6px;
  padding-bottom: 0px;
`

export const TextArea = styled.textarea`
  ${TypeStyle.css.bodyDefault}
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.65px;
  box-sizing: border-box;
  padding: 9px 18px;
  width: 100%;
  height: 179px;
  resize: vertical;

  /* iOS Safari specific fix to prevent zoom */
  &:focus {
    @supports (-webkit-touch-callout: none) {
      font-size: 16px;
    }
  }
`
